import {onJSBridgeConnected, onWebviewshow, VideoBridgeInit, VideoBridgeReadyStatusHasReady} from "../api";
import BigTemplate from "./template/BigTemplate";
import VideoTemplate from "./template/VideoTemplate";
import VConsole from 'vconsole'
import Unit from "./Unit";

let vConsole
function getVConsoleInstance(){
    vConsole = vConsole || new VConsole()
    return vConsole
}

let linstenerList = []


export default {

    enableDebugMode() {
        getVConsoleInstance()
    },

    onJSBridgeConnected,
    onWebviewshow,
    videoBridgeReadyStatusHasReady:VideoBridgeReadyStatusHasReady,

    fetchDataSource() {
        return new Promise(async (resolve, reject) => {
            try{
                const res = await VideoBridgeInit()
                const { code, data={} } = res
                /*if(code === 0){
                    resolve(data)
                }else {
                    reject(new Errow('初始化数据失败'))
                }*/
                resolve(res)
            }catch(e){
                console.warn('初始化数据失败, 请确认当前环境为 mintegral SDK', e)
                reject(e)
            }
        })
    },
    initRootView(data){
        // const {campaignList, sdk_info, unit_id, appSetting, unitSetting, sdkSetting={instanceId}, device} = data
        const { unit_id, sdkSetting={ instanceId } } = data
        this.rootView = {
            type: 1, // 大模板的 ViewType 固定为 1
            id: instanceId,
            unitId: unit_id
        }
    },
    /**
     * 初始化单offer模板
     * @param VideoTpl
     * @param fetchFun
     */
    initSingleCampaign(VideoTpl, fetchFun = this.fetchDataSource ) {
        return new Promise((resolve, reject) => {
            if(!VideoTpl){
                reject(new Error('VideoTpl, 未指定相应模板'))
            }else if (! VideoTpl instanceof VideoTemplate){
                reject(new Error('单offer模板初始化参数错误'))
            }
            fetchFun().then((data)=>{
                this.mainOpts = data
                // this.initRootView(data)
                const { campaignList, unitSetting } = data
                const unitId = unitSetting.id
                const campaign = campaignList[0]
                const unit = new Unit(unitId, unitSetting)
                const tpl = new VideoTpl({
                    campaign,
                    unit
                })
                unit.setTemplate(tpl)
                resolve(tpl, unit)
            }).catch(e => {
                reject(e)
            })
        })
    },
    /**
     * 初始化大模板
     * @param VideoTpl
     * @param fetchFun
     */
    initMultipleCampaigns(VideoTpl, fetchFun = this.fetchDataSource) {
        return new Promise((resolve, reject) => {
            if(!VideoTpl){
                reject('初始化参数错误，未指定相应模板')
            }else if (! VideoTpl instanceof BigTemplate){
                reject('大模板初始化参数错误')
            }
            fetchFun().then((data)=>{
                this.mainOpts = data
                // this.initRootView(data)
                const { campaignList, unitSetting } = data
                const unitId = unitSetting.unitId
                const unit = new Unit(unitId, unitSetting)
                const tpl = new VideoTpl({
                    // campaignList,
                    unit
                })
                unit.setTemplate(tpl)
                resolve({data, tpl, unit})
            }).catch(e => {
                reject(e)
            })
        })
    },
}